import { render, staticRenderFns } from "./tetrisclaimed.vue?vue&type=template&id=d7008356&"
import script from "./tetrisclaimed.vue?vue&type=script&lang=js&"
export * from "./tetrisclaimed.vue?vue&type=script&lang=js&"
import style0 from "spinkit/spinkit.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./tetrisclaimed.vue?vue&type=style&index=1&id=d7008356&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports